import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Drawer from "src/Components/Custom/Drawer/Drawer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler,{
  useAppState,
} from "src/StateHandlers/AppStateHandler";
 
function Settings() {
  const [{ showSidebar }] = useAppState();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const handleLangaugeModal = (e: any) => {
    e.preventDefault();
    setShowModal(true);
  }

  const handleLangauge = (lang: "en" | "fr" | "ar") => {
    AppStateHandler.setLocale(lang)
  }

  return (
    <Fragment>
      <div className={showSidebar ? "" : "toggle_class"}>
        <UserNavBar />
        <div className="wrapper">
          <Drawer />
          <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-9">
                  <div className="col_selector bg-white post_feed rounded px-3">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="col_selector mb-5 setting_shadow text-center">
                          <Link className="p-4 d-inline-block" to="/about">
                            <img
                              src="assets/images/about@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">{t('About Us')}</p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="col_selector mb-5 setting_shadow text-center">
                          <Link className="p-4 d-inline-block" to="/faq">
                            <img
                              src="assets/images/faq@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">{t('FAQ')}</p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="col_selector mb-5 setting_shadow text-center">
                          <Link
                            className="p-4 d-inline-block"
                            to="/terms-and-condition"
                          >
                            <img
                              src="assets/images/term@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">
                              {t('Terms & Conditions')}
                            </p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="col_selector mb-5 setting_shadow text-center">
                          <Link
                            className="p-4 d-inline-block"
                            to="/privacy-policy"
                          >
                            <img
                              src="assets/images/privacy@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">{t('Privacy Policy')}</p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="col_selector setting_shadow text-center">
                          <Link className="p-4 d-inline-block" to="/contact-us">
                            <img
                              src="assets/images/contact@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">{t('Contact Us')}</p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="col_selector setting_shadow text-center">
                          <a className="p-4 d-inline-block" href="/" onClick={handleLangaugeModal}>
                            <img
                              src="assets/images/language@2x.png"
                              className="mb-4"
                              alt=""
                            />
                            <p className="p-0 text-center">{t('Languages')}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Fragment>
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            id="confirm_post"
            style={{ display: showModal ? "block" : "none" }}
            role={"dialog"}
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content border-0">
                <div className="modal-header p-4">{t("Select Language")}
                  <i className="fa fa-times pt-1 cursor-pointer" onClick={() => setShowModal(false)}></i>
                </div>
                <div className="modal-body p-3 p-md-5 custom_modal">
                  <div className="text-left">
                    <p className="d-flex align-items-center justify-content-between cursor-pointer pb-2" onClick={() => handleLangauge('en')}>
                      <span>
                        <img src="/assets/images/usa@2x.png" alt="" />
                        <span className={`${i18n.dir()==='rtl'?'pr-3':'pl-3'}`}>{t("English")}</span>
                      </span>
                      {language === 'en' ? <i className="fa fa-check base_color" aria-hidden="true"></i> : <></>}
                    </p>
                    <p className="d-flex align-items-center justify-content-between cursor-pointer" onClick={() => handleLangauge('fr')}>
                      <span>
                        <img src="/assets/images/franch@2x.png" alt="" />
                        <span className={`${i18n.dir()==='rtl'?'pr-3':'pl-3'}`}>{t("French")}</span>
                      </span>
                      {language === 'fr' ? <i className="fa fa-check base_color" aria-hidden="true"></i> : <></>}
                    </p>
                    <p className="d-flex align-items-center justify-content-between cursor-pointer" onClick={() => handleLangauge('ar')}>
                      <span>
                        <img src="/assets/images/arabic@2x.png" alt="" />
                        <span className={`${i18n.dir()==='rtl'?'pr-3':'pl-3'}`}>{t("Arabic")}</span>
                      </span>
                      {language === 'ar' ? <i className="fa fa-check base_color" aria-hidden="true"></i> : <></>}
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <VisibilityToggle visible={showModal ? true : false}>
            <div
              className={`modal-backdrop fade ${showModal ? "show" : ""}`}
              onClick={() => setShowModal(false)}
            ></div>
          </VisibilityToggle>
        </Fragment>
      </div>
    </Fragment >
  );
}

export default Settings;
